<template>
   <Frame class="register" :name="title">
      <Step class="steps" :current="current" />
      <component :is="moduleId"></component>
      <Modal class="register-tip-modal" title="友情提醒" v-model="isShowMask" centered :closable="false" :footer="null" :width="500" >
         {{tipContent}}
      </Modal>
   </Frame>
</template>
<script>
import { mapState } from 'vuex'
import { Modal } from 'ant-design-vue'
import Frame from '@components/commonFramework/index'
import Step from './component/step'

export default {
   data() {
      return {
         moduleId: '',
         title: '欢迎注册'
      }
   },
   computed: {
      ...mapState(['footerInfo']),
      current() {
         const cur = this.$route.query.step - 0 || 1
         this.moduleId = `step${cur}`
         const component = () => import(`./component/${this.moduleId}`)
         this.$options.components[this.moduleId] = component
         return cur
      },
      isShowMask() {
         return this.footerInfo && this.footerInfo.switchRegister && this.footerInfo.switchRegister.isShowRegister
      },
      tipContent() {
         return this.footerInfo && this.footerInfo.switchRegister && this.footerInfo.switchRegister.title
      }
   },
   components: {
      Frame,
      Step,
      Modal
   }
}
</script>
<style lang="scss">
.register{
   .steps{
      margin-top: 40px;
   }
   .content{
      display: flex;
      flex-direction: column;
      align-items: center;
   }
   // .ant-form-item-label{
   //    font-size: 13px;
   //    color: #333333;
   // }
   .form-item-value{
      width: 160px;
   }
   .form-help{
      padding-left: 7px;
      font-size: 13px;
      white-space: nowrap;
      word-break: keep-all;
      display: flex;
      align-items: center;

      img{
         width: 13px;
         height: 13px;
         margin-right: 3px;
      }

      a{
         font-size: 12px;
         color: #116CD0;
         text-decoration: underline;
         padding-left: 4px;
         margin-right: 10px;
      }
   }
   .register-section{
      padding-top: 60px;
      width: 900px;

      input {
        width: 260px;
        height: 38px;
        color: #333;
      }
      .ant-form input[type='checkbox']{
         width: 60px;
      }
      .ant-btn-primary{
         background: #1C7AE5;
         border:0;
         border-radius: 2px;
         height: 38px;
         font-size: 14px;
         color: #FFFFFF;
      }
      .ant-btn-primary[disabled]{
         background: #d9d9d9;
      }
      .ant-btn-default.noraml-bt{
         margin-left: 20px;
         height: 38px;
         font-size: 14px;
         border-radius: 2px;
      }
      .ant-form-item{
         margin-bottom: 20px;
      }
      // .ant-form-item-control{
      //    display: flex;

      //    .ant-form-explain{
      //       padding-left: 20px;
      //    }
      // }
   }
   .register-tip-modal{
      .ant-modal-body{
         text-align: center;
      }
   }
}

</style>